import { Button } from "@/components/ui/button";
import { Ellipsis, Share } from "lucide-react";
import React from "react";
import PrescriptionsList from "./prescriptions-list";
import PrescriptionsOverviewHeader from "./prescriptions-overview-header";

const Component: React.FC = () => {
    return (
        <div className="flex flex-col items-start justify-start p-2 gap-y-4">
            <div className="flex flex-row items-center justify-between w-full">
                <span className="text-2xl font-medium">Prescriptions</span>
                <div className="flex flex-row items-center justify-end gap-x-2">
                    <Button variant="ghost" className="flex flex-row items-center justify-center gap-x-2">
                        <Share className="h-5 w-5"/>
                        <span>Share as report</span>
                    </Button>
                    <Button variant="ghost" className="p-1"><Ellipsis /></Button>
                </div>
            </div>
            <PrescriptionsOverviewHeader />
            <PrescriptionsList />
        </div>
    );
}

export default Component;